import { gql } from "@apollo/client";

export const GET_PRODUCT_REVIEWS = gql`
  query ($lang: Iso639!, $input: ProductsInput, $limit: Int) {
    products(input: $input) {
      records {
        id
        translation(lang: $lang) {
          name
        }
        reviews(limit: $limit) {
          totalRecords
          records {
            id
            profileImageUrl
            stars
            text
            userName
            booking {
              group {
                guides {
                  id
                  nickName
                  profilePic
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const flattenReviews = (reviewsArray) => {
  const flattened = reviewsArray.reduce(
    (acc, curr) => {
      acc.totalRecords += curr.reviews.totalRecords;
      acc.records = acc.records.concat(
        curr.reviews.records.map((r) => {
          return {
            ...r,
            product: { id: curr.id, translation: curr.translation },
          };
        })
      );
      return acc;
    },
    { totalRecords: 0, records: [] }
  );

  return flattened;
};
